import { SimpleGrid } from '@chakra-ui/react'

export default SimpleGrid
